import React from 'react';
import BlogDetailContainer from 'containers/BlogDetailContainer';

export default function BlogDetailPage() {
  return <BlogDetailContainer />;
}
